import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home, Sparkles, Star } from "lucide-react";

const NotFound = () => {
  return (
    <div className="relative flex min-h-[calc(100vh-4rem)] flex-col items-center justify-center overflow-hidden bg-dreamy px-4 text-center">
      <div
        aria-hidden
        className="pointer-events-none absolute -top-24 left-1/2 h-96 w-96 -translate-x-1/2 rounded-full bg-primary/15 blur-3xl animate-aurora"
      />
      <Star
        aria-hidden
        className="pointer-events-none absolute left-[18%] top-[24%] h-6 w-6 text-primary/30 animate-drift"
      />
      <Sparkles
        aria-hidden
        className="pointer-events-none absolute right-[16%] top-[60%] h-7 w-7 text-primary/30 animate-drift"
        style={{ animationDelay: "1.5s" }}
      />

      <Compass className="mb-6 h-14 w-14 text-primary animate-float" />

      <h1 className="text-7xl font-bold tracking-tight sm:text-8xl">
        <span className="text-gold-shimmer">404</span>
      </h1>

      <p className="mt-5 max-w-md text-lg text-muted-foreground">
        Well, this is a curious little corner. The page you're after wandered
        off somewhere into the daydream — but every wrong turn is just a new
        adventure.
      </p>

      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 font-medium text-primary-foreground transition-transform hover:-translate-y-0.5 hover:glow-gold"
      >
        <Home className="h-4 w-4" />
        Whisk me home
      </Link>
    </div>
  );
};

export default NotFound;
